import { TableService } from './table-service';
import { Batch } from '../../../models/batch';
import { BatchQuery } from '../../../models/batch-query';
import { Observable, of } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectBatchTableBusy, selectBatchTableCount,
    selectBatchTablePage,
    selectBatchTableQuery,
    selectBatchTableSelection
} from '../../../store/batch-table/batch-table.state';
import { BatchColumnEnum } from '../../../enum/batch-column.enum';
import {
    batchTableChangePage,
    batchTableMasterToggle,
    batchTableSort,
    batchTableToggle
} from '../../../store/batch-table/batch-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class BatchTableService extends TableService<Batch, BatchQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectBatchTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            BatchColumnEnum.BATCH_NAME,
            BatchColumnEnum.BATCH_DATE,
            BatchColumnEnum.BATCH_COUNT,
            BatchColumnEnum.BATCH_PREPARING_COUNT,
            BatchColumnEnum.BATCH_MANIFESTED_COUNT,
            BatchColumnEnum.BATCH_IN_TRANSIT_COUNT,
            BatchColumnEnum.BATCH_DELIVERED_COUNT,
            BatchColumnEnum.BATCH_EXCEPTION_COUNT,
            BatchColumnEnum.BATCH_VOID_COUNT,
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Batch[]> {
        return this.store.select(selectBatchTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.BATCH;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectBatchTableSelection);
    }

    protected getTableQueryObservable(): Observable<BatchQuery> {
        return this.store.select(selectBatchTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectBatchTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(batchTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(batchTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(batchTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(batchTableMasterToggle());
    }

    protected getWidthBufferPx(): number {
        return super.getWidthBufferPx() + 50;
    }

}
